<form class="drop-padding" (ngSubmit)="save()" [formGroup]="cityForm">
  <mat-form-field appearance="outline">
    <mat-label>Название</mat-label>
    <input matInput type="text" placeholder="Название" formControlName="description" />
  </mat-form-field>
  <button mat-flat-button color="primary" type="submit">Сохранить</button>
</form>
